import { render, staticRenderFns } from "./OnboardingButton.vue?vue&type=template&id=8ad56aea&scoped=true&"
import script from "./OnboardingButton.vue?vue&type=script&lang=js&"
export * from "./OnboardingButton.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingButton.vue?vue&type=style&index=0&id=8ad56aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad56aea",
  null
  
)

export default component.exports